var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "title mt-5" }, [
      _c("h3", { staticClass: "d-flex justify-content-center header" }, [
        _vm._v("\n      " + _vm._s(_vm.$t("headers.hearing_test")) + "\n    ")
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "mt-3" }, [
      _c("div", { staticClass: "content" }, [
        _c("div", { staticClass: "d-flex justify-content-center" }, [
          _c("span", { staticClass: "header header-2" }, [
            !_vm.testHasStarted
              ? _c("span", [
                  _vm._v(_vm._s(_vm.$t("numbers_test.adjust_volume")))
                ])
              : _c("span", [_vm._v(_vm._s(_vm.$t("words_test.choose")))])
          ])
        ]),
        _vm._v(" "),
        !_vm.testHasStarted
          ? _c(
              "div",
              { staticClass: "d-flex justify-content-center mt-md-5" },
              [
                _c("img", {
                  staticClass: "sound-icon",
                  attrs: { src: "public/sound.svg", alt: "" }
                })
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        !_vm.testHasStarted
          ? _c("div", { staticClass: "d-flex justify-content-center mt-5" }, [
              _c(
                "button",
                {
                  staticClass: "button primary",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.startTest()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("actions.start")))]
              )
            ])
          : _c("div", [
              _c(
                "div",
                { staticClass: "d-flex justify-content-around w-100" },
                [
                  !_vm.isMobileDevice
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "d-flex justify-content-end sound-wrapper"
                        },
                        [
                          _vm.showAnimations && _vm.showLeftAnimation
                            ? _c("img", {
                                staticClass: "sound-waves",
                                attrs: { src: _vm.leftImage }
                              })
                            : _vm._e()
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "transition-group",
                    {
                      staticClass:
                        "row justify-content-md-center words-wrapper",
                      class: { clickable: !_vm.disableButtons },
                      attrs: { name: "list", tag: "div" }
                    },
                    _vm._l(_vm.words, function(word) {
                      return _c(
                        "div",
                        {
                          key: word.id,
                          staticClass: "flip-card col-4 col-md-4 grid-word",
                          class: word.class,
                          on: {
                            click: function($event) {
                              return _vm.evaluateCalibrationAnswer(word)
                            }
                          }
                        },
                        [
                          _c("div", { staticClass: "flip-card-inner" }, [
                            _c("div", { staticClass: "flip-card-front" }, [
                              _c("img", {
                                staticClass: "normal-image",
                                attrs: {
                                  src: _vm.getFullImagePath(word),
                                  alt: ""
                                }
                              }),
                              _vm._v(" "),
                              _c("img", {
                                staticClass: "hover-image",
                                attrs: {
                                  src: _vm.getFullImagePathHover(word),
                                  alt: ""
                                }
                              }),
                              _vm._v(" "),
                              _c("img", {
                                staticClass: "selected-image",
                                attrs: {
                                  src: _vm.getFullImagePathSelected(word),
                                  alt: ""
                                }
                              })
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "flip-card-back" }, [
                              _c("i", { staticClass: "far fa-check-circle" })
                            ])
                          ])
                        ]
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  !_vm.isMobileDevice
                    ? _c(
                        "div",
                        { staticClass: "d-flex justify-content-start" },
                        [
                          _vm.showAnimations && _vm.showRightAnimation
                            ? _c("img", {
                                staticClass: "sound-waves",
                                attrs: { src: _vm.rightImage }
                              })
                            : _vm._e()
                        ]
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "d-flex justify-content-center mt-3" }, [
                _c("span", { staticClass: "header header-4" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.$t("numbers_test.completed")) +
                      " "
                  ),
                  _c("b", [_vm._v(_vm._s(_vm.percentageCompleted) + " %")])
                ])
              ])
            ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }